const state = {
    token: '',
    baseURL: 'http://182.92.195.137',
    project_id: ''
}

const mutations = {
    setToken(state, value) {
        state.token = value
    },
    setBaseURL(state, value) {
        state.baseURL = value
    },
    setProjectId(state, value) {
        console.log('value', value)
        state.project_id = value
    }
}

const actions = {

}

export default {
    state,
    mutations,
    actions
}